import { inputtypesDate } from 'modernizr-esm/feature/inputtypes';
import moment from 'moment';
import Pikaday from 'pikaday';

export default function addDatePickers() {
  if (!inputtypesDate) {
    document.querySelectorAll('input[type=date]').forEach((input) => {
      var options = {
        field: input,
        format: 'YYYY-MM-DD',
        yearRange: [1900, moment().year()],
      };
      if (input.getAttribute('max')) {
        options.maxDate = moment(input.getAttribute('max')).toDate();
      }
      new Pikaday(options);
    });
  }
}
